import { URLBACKEND, API } from '@app/config/constants';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CsrfService } from '@app/services/csrf.service';

@Injectable()
export class EnviosService {
  private httpClient = inject(HttpClient);
  private csrfService = inject(CsrfService);

  desencriptar(file: File): Observable<Blob> {
    const formData = new FormData();
    if (this.csrfService.token) {
      formData.append('_csrf', this.csrfService.token);
    }
    formData.append('documento', file);

    return this.httpClient.post(URLBACKEND + API + 'envios/desencriptar', formData, {
      withCredentials: true,
      responseType: 'blob',
    });
  }

  enviar(file: File, parametros: Record<string, string | string[]>): Observable<string> {
    const formData = new FormData();

    Object.keys(parametros).forEach((key) => {
      const value = parametros[key];
      formData.append(key, Array.isArray(value) ? value.join(';') : value);
    });

    if (this.csrfService.token) {
      formData.append('_csrf', this.csrfService.token);
    }
    formData.append('documento', file);

    return this.httpClient.post(URLBACKEND + API + 'envios/crear', formData, {
      withCredentials: true,
      responseType: 'text',
    });
  }
}
